export const Footer = () => {
  return (
    <footer className={"nc-common-footer"}>
      <div>
        <div>
          <div className="c-footer__upper">
            <div className="c-footer__nav-container">
              <div className="c-footer-nav_menu">
                <ul className="c-footer-nav__list">
                  <li className="c-footer-nav__list-item"><a className="c-footer-nav__link" href="https://accounts.nicho.co.jp/help/help.html">よくあるご質問・お問い合わせ</a></li>
                  <li className="c-footer-nav__list-item"><a className="c-footer-nav__link" href="https://accounts.nicho.co.jp/help/requirements.html">ご利用環境について</a></li>
                  <li className="c-footer-nav__list-item"><a className="c-footer-nav__link" href="https://www.nicho.co.jp/" target="_blank">日本調剤サイト</a></li>
                  <li className="c-footer-nav__list-item"><a className="c-footer-nav__link" href="https://www.nicho.co.jp/corporate/" target="_blank">企業情報</a></li>
                  <li className="c-footer-nav__list-item"><a className="c-footer-nav__link" href="https://accounts.nicho.co.jp/help/termsandconditions.html">利用規約</a></li>
                  <li className="c-footer-nav__list-item"><a className="c-footer-nav__link" href="https://accounts.nicho.co.jp/help/privacy.html">個人情報の取扱いについて</a></li>
                  <li className="c-footer-nav__list-item"><a className="c-footer-nav__link" href="https://www.nicho.co.jp/security/" target="_blank">情報セキュリティポリシー</a></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="c-footer__lower">
            <div className="c-footer__copyright">© NIHON CHOUZAI Co., Ltd. All rights reserved.</div>
          </div>
        </div>
      </div>
    </footer>
  );
};
